import React from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import locale from "../../utils/locale";
const style = {
  background: '#0A5DB8',
};
const AddressDisplay = ({
  addressLine1,
  addressLine2,
  city,
  state,
  zip,
  isPartialMatch,
  disableClick,
  onChangeAddressClick
}) => {
  const textColorClass = isPartialMatch ? "text-red text-right" : "normal-color text-right";
  return (
    <div className="form-field">
      <Grid container spacing={24} className="custom-grid">
        <Grid item xs={6} sm={6}>
          <strong>{locale("address")}</strong>
        </Grid>
        <Grid className={textColorClass} item xs={6} sm={6}>
          <p style={{ marginTop: 0 }}>{addressLine1}</p>
          <p>{addressLine2}</p>
          <p>
            {city},{state},{zip}
          </p>
        </Grid>
      </Grid>
      <Button
        disabled={disableClick}
        className="br-25"
        fullWidth
        variant="raised"
        color="primary"
        style={style}
        onClick={() => onChangeAddressClick(true)}
      >
        {locale("changeAddress")}
      </Button>
    </div>
  );
};

AddressDisplay.propTypes = {
  addressLine1: PropTypes.string,
  addressLine2: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zip: PropTypes.string,
  isPartialMatch: PropTypes.bool,
  onChangeAddressClick: PropTypes.func,
  disableClick: PropTypes.bool
};

export default AddressDisplay;



// WEBPACK FOOTER //
// ./src/components/AddressDisplay/index.js